export const SET_AVVISO = 'SET_AVVISO';
